import { Route } from '@angular/router';
import { TendersListComponent } from '../../../../pages';
import { TenderListResolver } from '../../../resolvers';
import { IsBuyerGuard } from '../../../../../auth/routing/guards';

export const activeTenderListRoute: Route = {
    path: 'active',
    component: TendersListComponent,
    //canActivate: [IsBuyerGuard],
    resolve: {
        tenders: TenderListResolver
    }
};
